import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import axios from "axios";
import ectoollogo from "../../assets/images/ectool_Logo_2019.png";
import { API_BASE_URL } from "../../constants/apiConstants";
import { TextField, Box, Card, CardContent, Button, Grid, Typography } from "@mui/material";
import { VERSION } from "../../constants/version";
import { isBrowser, isMobile, osName, osVersion, browserVersion, browserName, mobileModel } from "react-device-detect";
import { useMessage } from "../../context/message-context";
import { useLocalStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useNavigate } from "react-router-dom";
import { DEBUG_FLAG } from "../../constants/debug";
import { SupportButton } from "../SupportComponent/Support";
import { useZulassung } from "../../context/zulassungs-context";
function LoginUser() {
  const { t } = useTranslation();
  const [username, setUsername] = useLocalStorage(LOCAL_STORAGE_KEY.username);
  const [, setRefreshToken] = useLocalStorage(LOCAL_STORAGE_KEY.refreshToken);
  const [usernameValue, setUsernameValue] = useState("");
  const [deviceId, setDeviceId] = useLocalStorage(
    DEBUG_FLAG() ? LOCAL_STORAGE_KEY.deviceIdLocal : LOCAL_STORAGE_KEY.deviceId
  );
  const [error, setError] = useState("");
  const { showErrorMessage } = useMessage();
  const [deviceVersion] = useState(localStorage.getItem(LOCAL_STORAGE_KEY.version) || VERSION);
  const { updateMandant, updatePrograms } = useZulassung();
  const [SSODomain, setSSODomain] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    // SSO-Daten aus dem Cache löschen
    if (window && window.sessionStorage && window.sessionStorage.getItem("SSO"))
      window.sessionStorage.removeItem("SSO");
    updateMandant("");
    updatePrograms([]);
  }, []);

  const handleSubmitClick = (e) => {
    if (e) e.preventDefault();
    var payload = {};
    if (isMobile) {
      payload = {
        username: usernameValue,
        deviceId: deviceId,
        device: mobileModel,
        os: osName,
        osBez: mobileModel + " " + osName + " " + osVersion,
        clientVersion: deviceVersion,
        clientBuild: VERSION,
      };
    }
    if (isBrowser) {
      payload = {
        username: usernameValue,
        deviceId: deviceId,
        browser: browserName + " " + browserVersion,
        os: osName,
        osBez: osName + " " + osVersion + " " + browserName + " " + browserVersion,
        clientVersion: deviceVersion,
        clientBuild: VERSION,
      };
    }
    axios
      .post(API_BASE_URL + "login/user", payload)
      .then(function (response) {
        if (username !== usernameValue) {
          setRefreshToken("");
        }
        setError("");
        setUsername(usernameValue);
        if (response.data.deviceId) {
          setDeviceId(response.data.deviceId);
        }
      })
      .catch(function (err) {
        console.log(err);
        if (err.response) {
          console.log(err.response.status);
          console.log(err.response.data.message);
          setError(err.response.data.message);
        } else {
          showErrorMessage(t("Netzwerkfehler. Sind Sie mit dem Internet verbunden?"));
        }
      });
  };

  useEffect(() => {
    if (!usernameValue) return;
    if (!SSODomain) return;
    if (usernameValue === "@" + SSODomain) handleSubmitClick();
  }, [usernameValue, SSODomain]);

  // .. im Falle Anwender ruft die SSO-URL (manuell) erneut auf? (bspw. Browser zurück)
  if (window && window.location && window.location.pathname && window.location.pathname.toLowerCase() === "/sso") {
    let sso_domain = "";

    // Schnelleinstieg mit Vorgabe SSO-Domäne > Benutzername
    if (window.location.search.startsWith("?domain=") && !window.location.search.includes("&")) {
      sso_domain = window.location.search.slice(8);

      // Angabe übernehmen, falls noch nicht gesetzt
      if (sso_domain && usernameValue !== "@" + sso_domain && SSODomain !== sso_domain) {
        setSSODomain(sso_domain);
        setUsernameValue("@" + sso_domain);
      }

      // Wenn Benutzername (SSO-Domäne) nicht gültig, dann URL (Location) umbiegen (für 'Standard'-Login)
      // .. oder wir machen vorerst nichts und lassen alles stehen ;) .. -.- geht nicht, dann kann man keinen anderen Benutzernamen eingeben
      if (sso_domain && SSODomain === sso_domain && error) {
        let url_fallback = window.location.origin;
        // Hash behalten für Direkt-Einstieg
        if (window.location.hash) url_fallback += "/" + window.location.hash;
        window.location.replace(url_fallback);
        //  window.location.pathname = '';
        //  window.location.search = '';
        // .. Info-Seite? .. so sieht man ganz kurz Anmeldename und die Standard-Fehlermeldung ;)
        //  return <>SSO-Domain invalid .. you will be redirected</>;
      }
    }

    if (!sso_domain) {
      let url_fallback = window.location.origin;
      if (window.location.hash) url_fallback += "/" + window.location.hash;
      window.location.replace(url_fallback);
      return <>'/sso' invalid .. you will be redirected</>;
    }
  }

  return (
    <Box p={2}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} sm={8} md={6}>
              <Card>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <img src={ectoollogo} height="50" alt="ectool" loading="lazy" />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h5">{t("Herzlich Willkommen")}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {t("Geben Sie Ihren Benutzernamen ein um sich bei ectool anzumelden.")}
                      </Typography>
                    </Grid>
                  </Grid>
                  <form>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          error={error !== ""}
                          helperText={error}
                          autoComplete="off"
                          type="text"
                          label={t("Benutzername / E-Mail")}
                          variant="outlined"
                          id="username"
                          aria-describedby="emailHelp"
                          placeholder="Benutzername eingeben ..."
                          value={usernameValue}
                          onChange={(e) => setUsernameValue(e.target.value)}
                          inputProps={{
                            autoCapitalize: "off",
                            autoCorrect: "off",
                            spellCheck: "false",
                          }}
                        />
                        <Typography variant="body2">{t("Benutzername oder E-Mail-Adresse")}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Button type="submit" variant="contained" color="primary" fullWidth onClick={handleSubmitClick}>
                          {t("Weiter")}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </CardContent>
              </Card>
              <Box p={2} pt={4}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <Typography variant="body1">{t("Benötigen Sie Hilfe?")}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      href="https://docs.ectool.de/app/erste-anmeldung-in-der-ectool-app/"
                      color="primary"
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="outlined"
                    >
                      {t("Anleitung Erstanmeldung")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <Typography variant="body1">
                        {t("Für weitere Hilfe können Sie unseren Support kontaktieren")}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <SupportButton callLocation="Benutzername" />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
export default LoginUser;
